import { fromPromise } from 'xstate';
import { apolloClient } from '@/lib/apollo';
import { FindClientsQuery, RegisterClientMutation } from '@/lib/gql/__generated__/canonical-documents';
import type { RegisterClientInput } from '@/lib/gql/__generated__/graphql';

export const findClientsActor = fromPromise(async () => {
  const result = await apolloClient.query({ query: FindClientsQuery });
  if (!result.data) throw new Error('The client list could not be loaded.');
  return result.data.findClients;
});

export const registerClientActor = fromPromise<boolean, RegisterClientInput>(async ({ input }) => {
  const result = await apolloClient.mutate({
    mutation: RegisterClientMutation,
    variables: {
      input: {
        clientId: input.clientId,
        clientName: input.clientName,
        fiduciaryName: input.fiduciaryName,
        beneficiaries: input.beneficiaries.map((beneficiary) => ({
          beneficiaryName: beneficiary?.beneficiaryName ?? '',
        })),
      },
    },
  });
  if (!result.data?.registerClient.success) {
    throw new Error(result.data?.registerClient.error?.message ?? 'The client could not be registered.');
  }
  return true;
});
